// extracted by mini-css-extract-plugin
export default {"container":"FAQBlock_container__zP9sa Content_content__b7wDI"};